import { deleteAlert } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const DeleteAlert = async (coin, subAccount, alertId, accessToken)  => {
  try {
    const response = await deleteAlert(coin, subAccount, alertId, accessToken);
    return { success: true, data: response.data };
  } catch (error) {    
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default DeleteAlert;
